import ReactDOM from 'react-dom/client'
import { PermifyProvider as OriginPermifyProvider } from '@permify/react-role';
// import { VITE_GOOGLE_RECAPCHA_SITE_KEY } from './private/config';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { store, persistor } from './redux/store';
import { LangProvider } from 'i18n/index';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './reactQuery/queryClient'; // ตรวจสอบว่าคุณมีการตั้งค่า QueryClient
// import {
//   GoogleReCaptchaProvider
// } from 'react-google-recaptcha-v3';
import './index.css'

export const PermifyProvider: any = OriginPermifyProvider

// ReactDOM.hydrateRoot(
//   document.getElementById('root')!,
//   <Provider store={store}>
//     {/* <GoogleReCaptchaProvider
//     reCaptchaKey={VITE_GOOGLE_RECAPCHA_SITE_KEY}
//     useRecaptchaNet={true}
//     scriptProps={{
//       async: false, // optional, default to false,
//       defer: false, // optional, default to false
//       appendTo: 'body', // optional, default to "head", can be "head" or "body",
//       nonce: undefined // optional, default undefined
//     }}
//     container={{ // optional to render inside custom element
//         // element: '[required_id_or_htmlelement]',
//       parameters: {
//         badge: 'bottomright', // optional, default undefined
//         theme: 'light' // optional, default undefined
//       }
//     }}

//     > */}
//     <PersistGate persistor={persistor}>
//       <LangProvider>
//         <PermifyProvider>
//           <BrowserRouter>
//             <App />
//           </BrowserRouter>
//         </PermifyProvider>
//       </LangProvider>
//     </PersistGate>
//   {/* </GoogleReCaptchaProvider> */}
//   </Provider>
// );

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <LangProvider>
        <PermifyProvider>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryClientProvider>
        </PermifyProvider>
      </LangProvider>
    </PersistGate>
  </Provider>
);

// reportWebVitals();


// ReactDOM.createRoot(document.getElementById('root')!).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
// )
